import { apiService } from './api';
import { User, RequestUpdateAboutMeDTO, RequestChangeUserCityDTO, RequestAddUserSkillsDTO, EmploymentStatus } from '../types/user';
import { AxiosResponse } from 'axios';

export interface RequestUpdateEmploymentStatusDTO {
    employmentStatus: EmploymentStatus;
}

export const userService = {
    getMe(): Promise<AxiosResponse<User>> {
        return apiService.get<User>('/User');
    },

    getAllUsers(): Promise<User[]> {
        return apiService.get<User[]>('/user/admin/users').then(res => res.data);
    },

    updateAboutMe(data: RequestUpdateAboutMeDTO): Promise<AxiosResponse<void>> {
        return apiService.patch<void>('/User/aboutme', data);
    },

    changeCity(data: RequestChangeUserCityDTO): Promise<AxiosResponse<void>> {
        return apiService.patch<void>('/User/city', data);
    },

    addSkills(data: RequestAddUserSkillsDTO): Promise<AxiosResponse<void>> {
        return apiService.post<void>('/Skill/add', data);
    },

    updateEmploymentStatus(data: RequestUpdateEmploymentStatusDTO): Promise<AxiosResponse<User>> {
        return apiService.patch<User>('/User/employment-status', data);
    },
};
